import React, { Component } from 'react';
//import PropTypes from 'prop-types';
import './labels.scss';
import GeckoLabel from './label.jsx';
//import { GeckoBtnsModel } from '../../models';

class GeckoLabels extends Component {
  render() {
    return (
      <div className="gecko-labels">
        {this.props.items.map((label, i) => (
          <GeckoLabel name={label.name} type={label.type} key={i} />
        ))}
      </div>
    );
  }
}

GeckoLabels.defaultProps = {
  items: [],
};

// GeckoLabels.propTypes = {
//     items: GeckoBtnsModel
// };

export default GeckoLabels;
